/**
 *   Generated file. Do not edit
 */
import './converter-stream-extension';

import { BodyConverter } from '@iotize/tap/client/api';

import { ReadSelectedFileParams } from './models';
import { TapStreamReader } from '@iotize/tap/client/impl';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { enumKeyOrValueToNumber } from '@iotize/tap/client/impl';

export class ReadSelectedFileParamsConverter
  implements BodyConverter<ReadSelectedFileParams>
{
  public encode(
    model: ReadSelectedFileParams,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeReadSelectedFileParams(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): ReadSelectedFileParams {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readReadSelectedFileParams();
  }
}
